import { Link } from "react-router-dom";
import { Reveal } from "@/lib/motion";
import EraPathway from "@/components/site/EraPathway";

export default function BrandIntro() {
  return (
    <section
      data-testid="brand-intro-section"
      className="py-20 md:py-28 bg-white border-t border-ink/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-4">
          <div className="overline">Our perspective</div>
          <div className="mt-6 text-[13px] tracking-[0.06em] text-ink-soft uppercase">
            Sydney, NSW
          </div>
        </Reveal>
        <Reveal className="lg:col-span-8" delay={1}>
          <p className="font-serif-display text-3xl sm:text-4xl md:text-5xl leading-[1.08] tracking-tight text-ink">
            Businesses have always evolved. The tools have changed. The need for
            <em className="font-light"> structure, trust, communication </em>
            and good systems has not. ETradingGroup helps practical businesses
            move into the next stage — with clarity, structure, and
            <span className="text-brand-red"> AI-supported workflows</span>.
          </p>
        </Reveal>
      </div>

      {/* Era pathway — an evolution in six chapters */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-16 md:mt-20 hidden sm:block">
        <Reveal>
          <div className="flex items-end justify-between gap-4 mb-5">
            <span className="overline text-ink-soft">
              An evolution, in six chapters
            </span>
            <Link
              to="/about"
              data-testid="era-pathway-link"
              className="overline text-ink-soft hover:text-brand-red transition-colors hidden md:inline"
            >
              Read the full timeline →
            </Link>
          </div>
        </Reveal>
        <Reveal delay={1}>
          <EraPathway />
        </Reveal>
      </div>
    </section>
  );
}
